import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    role:{
        label : ""
    },
    roleList:[],

}

const role = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

export default role;